import { TrackingPageTypeWithoutId } from '@aboutyou/legacy-tracking-sdk'
import React, { FC } from 'react'

import DocumentHead from './components/DocumentHead'

import { PageTrackingContextProvider } from 'helpers/tracking/PageTrackingContext'
import { useTrackingPageUrl } from 'helpers/tracking/hooks/useTrackingPageUrl'
import { WelcomePageContentFocus } from 'pages/Welcome/components/WelcomePageContentFocus'

const WelcomePage: FC = () => {
  return (
    <div>
      <DocumentHead />
      <WelcomePageContentFocus />
    </div>
  )
}

const TrackedWelcomePage: FC = () => {
  const { path, search } = useTrackingPageUrl()

  return (
    <PageTrackingContextProvider
      path={path}
      search={search}
      type={TrackingPageTypeWithoutId.Welcome}
    >
      <WelcomePage />
    </PageTrackingContextProvider>
  )
}

export default TrackedWelcomePage
